import { featureEnabled, isCustomerAdmin, userFeatureEnabled } from "./helpers";

export interface ProjectReportMayInterface {
  (session: SessionInterface, path: "project-reports"): boolean;
  (session: SessionInterface, path: "project-reports", action: "new"): boolean;
  (
    session: SessionInterface,
    path: "project-reports",
    action: "edit" | "delete" | "show",
    customer: ProjectReportListItem,
  ): boolean;
}

const PROJECT_REPORT_PERMISSIONS: PermissionType<ProjectReportListItem> = {
  "project-reports": {
    index: ({ currentUser, currentProject }) => featureEnabled(currentUser, currentProject, "project-reports"),
    show: ({ currentUser, currentProject }) => featureEnabled(currentUser, currentProject, "project-reports"),

    new: ({ currentUser, currentCustomer, currentProject }) =>
      featureEnabled(currentUser, currentProject, "project-reports") &&
      (isCustomerAdmin(currentUser, currentCustomer) || userFeatureEnabled(currentUser, "project-reports/write")),
    edit: ({ currentUser, currentCustomer, currentProject }) =>
      featureEnabled(currentUser, currentProject, "project-reports") &&
      (isCustomerAdmin(currentUser, currentCustomer) || userFeatureEnabled(currentUser, "project-reports/write")),
    delete: ({ currentUser, currentCustomer, currentProject }) =>
      featureEnabled(currentUser, currentProject, "project-reports") &&
      (isCustomerAdmin(currentUser, currentCustomer) || userFeatureEnabled(currentUser, "project-reports/write")),
  },
};

export default PROJECT_REPORT_PERMISSIONS;
